import { render, staticRenderFns } from "./AssignVideoAction.vue?vue&type=template&id=1487547a"
import script from "./AssignVideoAction.vue?vue&type=script&lang=js"
export * from "./AssignVideoAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports